<template>
  <Error
    title="システムエラー"
    lead="サーバでエラーが発生しました"
  >
    <template #default>
      しばらく時間を置いてから、もう一度やり直してください。
    </template>
  </Error>
</template>

<script>
import Error from '@/components/Error.vue'

export default {
  navbar: false,
  components: {
    Error
  },
  metaInfo() {
    return {
      title: 'システムエラー',
      bodyAttrs: { class: 'error' }
    }
  }
}
</script>
